import { addMinutes } from 'date-fns';

import {
  UPDATE_SALE,
  START_SALE_REQUEST,
  START_SALE_SUCCESS,
  START_SALE_FAILURE,
  PROCESS_SALE_REQUEST,
  PROCESS_SALE_FAILURE,
  PROCESS_SALE_SUCCESS,
  RESERVE_REQUEST,
  RESERVE_SUCCESS,
  RESERVE_FAILURE,
  EXPIRE_PACKAGE,
  CLEAR_RESERVATIONS_SUCCESS,
  CLEAR_RESERVATION_SUCCESS,
  VALIDATION_PASSES_LOADING,
  VALIDATION_PASSES_FAILURE,
  VALIDATION_PASSES_SUCCESS,
  REMOVE_MEMBER_BENEFIT
} from '../constants/ActionTypes';

import emptySale from '../models/sale';
import formatTimeString from '../utils/formatTimeString';

export default function sale(
  state = {
    loading: false,
    error: null,
    errors: null,
    sale: emptySale(),
    validatedPasses: [],
    touched: {}
  },
  action
) {
  let nextState = null;

  const getSaleBenefits = validatedPasses => {
    let benefits = [];

    for (let i = 0; i < validatedPasses.length; i++) {
      const currentValidatedPassObj = validatedPasses[i];

      for (let j = 0; j < currentValidatedPassObj.benefitIds.length; j++) {
        const currentBenefitId = currentValidatedPassObj.benefitIds[j];

        const existingIndexOfCurrentBenefitId = benefits.findIndex(
          benefitObj => benefitObj.benefitId === currentBenefitId
        );

        if (existingIndexOfCurrentBenefitId > -1) {
          benefits[existingIndexOfCurrentBenefitId].pass_nos.push(
            currentValidatedPassObj.pass_no
          );
        } else {
          benefits.push({
            benefitId: currentBenefitId,
            pass_nos: [currentValidatedPassObj.pass_no]
          });
        }
      }
    }

    return benefits;
  };

  switch (action.type) {
    case START_SALE_SUCCESS:
      nextState = {
        ...state,
        sale: {
          ...state.sale,
          ...action.sale,
          expiredPackages: false
        },
        error: null,
        loading: false
      };

      if (state.sale.id != null) {
        // clear it in case we have gotten here from a previous sale
        // can't use emptySale() because we already have sale.day
        nextState.sale.reservedPackages = {};
        nextState.sale.packages = {};
        nextState.sale.packageAddOns = {};
        nextState.sale.packageAddOnGuests = {};
      }

      break;
    case UPDATE_SALE:
      nextState = {
        ...state,
        sale: {
          ...state.sale,
          ...action.sale
        },
        error: null,
        loading: false
      };
      break;

    case PROCESS_SALE_SUCCESS:
      nextState = {
        ...state,
        done: true,
        emailBody: action.emailBody,
        error: null,
        loading: false
      };
      break;

    case START_SALE_REQUEST: // fall-through
    case PROCESS_SALE_REQUEST: // fall-through
      nextState = {
        ...state,
        loading: true,
        error: null
      };
      break;

    case START_SALE_FAILURE: // fall-through
    case PROCESS_SALE_FAILURE: // fall-through
      nextState = {
        ...state,
        loading: false,
        error: action.error,
        errors: action.errors
      };
      break;

    case EXPIRE_PACKAGE:
      nextState = {
        ...state,
        sale: {
          ...emptySale(),
          expiredPackages: true
        }
      };
      break;
    case CLEAR_RESERVATIONS_SUCCESS:
      nextState = {
        ...state,
        sale: {
          ...state.sale,
          reservedPackages: {}
        }
      };
      break;
    case CLEAR_RESERVATION_SUCCESS:
      nextState = {
        ...state,
        sale: {
          ...state.sale,
          reservedPackages: {
            ...state.sale.reservedPackages
          }
        }
      };

      delete nextState.sale.reservedPackages[action.pkgId];

      break;
    case RESERVE_REQUEST:
      nextState = {
        ...state,
        loading: true,
        sale: {
          ...state.sale,
          reservedPackages: {
            ...state.sale.reservedPackages,
            [action.pkg.item_id]: {
              ...state.sale.reservedPackages[action.pkg.item_id],
              loading: true
            }
          }
        }
      };
      break;
    case RESERVE_FAILURE:
      var time =
        state.sale == null ||
        state.sale.packages == null ||
        state.sale.packages[action.pkg.item_id] == null ||
        state.sale.packages[action.pkg.item_id].time == null
          ? null
          : formatTimeString(
              state.sale.day,
              state.sale.packages[action.pkg.item_id].time
            );

      nextState = {
        ...state,
        loading: false,
        sale: {
          ...state.sale,
          reservedPackages: {
            ...state.sale.reservedPackages,
            [action.pkg.item_id]: {
              ...state.sale.reservedPackages[action.pkg.item_id],
              loading: false
            }
          }
        },
        error: `${
          state.error == null ? '' : `${state.error} `
        }Unable to reserve ${action.pkg.descrip}${
          time == null ? '' : ` for ${time}`
        }.`
      };

      delete nextState.sale.reservedPackages[action.pkg.item_id];
      delete nextState.sale.packages[action.pkg.item_id];
      delete nextState.sale.packageAddOns[action.pkg.item_id];
      delete nextState.sale.packageAddOnGuests[action.pkg.item_id];

      break;
    case RESERVE_SUCCESS:
      if (action.pkg == null) {
        nextState = {
          ...state,
          loading: false
        };
      } else {
        nextState = {
          ...state,
          loading: false,
          sale: {
            ...state.sale,
            reservedPackages: {
              ...state.sale.reservedPackages,
              [action.pkg.item_id]: {
                ...state.sale.reservedPackages[action.pkg.item_id],
                loading: false,
                itmres_no: action.itmres_no,
                expires: addMinutes(
                  action.date,
                  parseInt(action.reservationHoldMinutes, 10)
                )
              }
            }
          }
        };
      }
      break;

    case VALIDATION_PASSES_LOADING:
      nextState = {
        ...state,
        loading: true,
        error: null
      };
      break;
    case VALIDATION_PASSES_FAILURE:
      nextState = {
        ...state,
        loading: false,
        error: action.error,
        errors: action.errors
      };
      break;
    case VALIDATION_PASSES_SUCCESS:
      nextState = {
        ...state,
        sale: {
          ...state.sale,
          benefits: getSaleBenefits(action.validatedPasses)
        },
        validatedPasses: action.validatedPasses,
        error: null,
        loading: false
      };
      break;
    case REMOVE_MEMBER_BENEFIT:
      nextState = {
        ...state,
        sale: {
          ...state.sale,
          benefits: state.sale.benefits.filter(
            benefit => benefit.pass_no !== action.passNumberToRemove
          )
        }
      };
      break;

    default:
      break;
  }

  return nextState || state;
}
